import { t } from 'i18next'
import React from 'react'

import { Chip, ChipProps } from '@mui/material'

type BetaBadgeProps = Omit<ChipProps, 'label' | 'size'>

const BetaBadge: React.FC<BetaBadgeProps> = (props) => {
  return <Chip label={t('common:beta').toLocaleUpperCase()} size="small" {...props} />
}

export default BetaBadge
